import { Fragment, useEffect } from "react";
import { Box, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGetParticipantsForCallSheetQuery } from "../../../../../graphql/generated/graphql";
import { useParams } from "react-router-dom";
import CircularLoading from "../../common/CircularLoading";
import TableParticipants from "./tableParticipants";
import {
  FormattedDateInverse,
  formatTime,
} from "../../../../helper/converters";

import "./index.scss";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 1000,
  height: "90vh",
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "20px",
};

const CallSheetModalParticipant = (props: any) => {
  const { open, onClose, id, callSheet, refetchListCallsheet } = props;
  const onlyDate = callSheet.date.split(" ");
  const dateCallsheet = onlyDate[0] + "T00:00:00";
  const params = useParams();

  const { data: participantsData, loading, refetch: refetchParticipants } =
    useGetParticipantsForCallSheetQuery({
      variables: {
        project_id: params.projectId || "",
        call_sheet_id: id,
      },
    });

  useEffect(() => {
    if (refetchListCallsheet && open) {
      refetchListCallsheet({
        project_id: params.projectId || "",
      });
      refetchParticipants({
        project_id: params.projectId || "",
        call_sheet_id: id,
      })
    }
  }, [open])

  return (
    <Modal
      open={open}
      onClose={() => onClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={style}
        className="participant-modal"
      >
        <IconButton
          onClick={onClose}
          className="close-participant-modal"
        >
          <CloseIcon />
        </IconButton>
        <div className="participant-modal-information">
          <h2>Call Sheet Confirmation</h2>
          <div>
            <span>
              General Call Time:{" "}
              {callSheet.time ? formatTime(callSheet.time) : ""} &nbsp;|&nbsp;
            </span>
            <span>
              Date: {callSheet.date ? FormattedDateInverse(dateCallsheet) : ""}
              &nbsp;|&nbsp;
            </span>
            <span>
              Confirmed {callSheet.confirmed_participants} OF{" "}
              {callSheet.total_participants}
            </span>
          </div>
        </div>
        <Box className="participant-modal-wrapper">
          {loading && <CircularLoading />}
          {participantsData?.getParticipantsForCallSheet &&
            participantsData?.getParticipantsForCallSheet.map(
              (group, index) => (
                <Fragment key={index}>
                  {index === 0 && <h2 key={"title" + index}>Crew</h2>}
                  {group?.title && (
                    <h2 key={"title" + index}>{group?.title}</h2>
                  )}
                  <TableParticipants
                    index={index}
                    participants={group}
                  />
                </Fragment>
              )
            )}
        </Box>
      </Box>
    </Modal>
  );
};
export default CallSheetModalParticipant;
